import styled from 'styled-components';
const baseFontSize = 16;

export const StyledValuePropPrompt = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  font-family: var(--font-family);
  font-size: ${baseFontSize};
  line-height: 1.1em;
  border: 1px solid var(--light-gray);

  .value-bullets {
    margin-top: 11px;
    list-style: none;
    padding: 0;
  }

  .bullet {
    display: flex;
    min-height: 1.5em;
    margin-bottom: 8px;

    .checkmark {
      min-width: 0.75em;
      display: inline-block;
      margin: 0.1875em 0.4375em 0 0;
      color: ${props => props.theme.merchantColor};
      fill: ${props => props.theme.merchantColor};
    }
  
    .text {
      display: inline-block;
      font-weight: 400;
      font-size: 14px;
      line-height: 125%;
  
      @media (min-width: 551px) {
        font-size: 1em;
        line-height: 1.125em;
      }
    }

    &.change-tab {
      display: flex;
      align-items: center;
    }
  }

  @media (max-width: 373px) { .header { font-size: 14px; } }
  @media (max-width: 345px) { .header { font-size: 13px; } }
  @media (max-width: 329px) { .header { font-size: 12px; } }
  @media (max-width: 316px) { .header { font-size: 11px; } }
`;

